<template>
  <div style="height: 100%">
    <div v-if="job.vgmChannel === 1 || isWse || isRongETong" style="height: 100%">
      <sea-house-vgm
        ref="seaHouseVgm"
        :job="job"
        :vas-channel="vasChannel"
        :readonly="readonly"
        :is-edit="isEdit"
        @syncData="syncData"
      />
    </div>
    <div v-show="job.vgmChannel === 0" class="tab-vgm" style="margin-top: 10px; width: 100%">
      <div class="section" style="width: 100%;padding-top: 10px;margin-left: 0px;">
        <div style="display: flex">
          <span class="title" style="width: 100px">{{ $t('CargoMsg.Cargo_VGMChannel') }}：</span>
          <el-radio-group v-model="localVgmChannel" style="width: 100%" :disabled="readonly" @change="changeLocalVgmChannel">
            <el-radio
              v-for="option in vgmChannels"
              :key="option.code"
              :label="option.code"
            >{{ isZh ? option.chineseName : option.englishName }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- 仅保存 -->
      <div>
        <div style="display: flex">
          <div class="section" style="width: 250px;flex: none">
            <cargo-ag-grid
              no="1"
              :grid-options="left.gridOptions"
              :grid-params.sync="left.gridParams"
              :column-defs="leftColumnDefs"
              :row-data="vgms"
              style="width:100%;height:350px"
              @gridReady="params=>{left.gridApi=params.api}"
            />
            <div style="display: flex;float:right;margin:5px 0">
              <el-button no="2" type="primary" :disabled="readonly" @click="addHandler">{{ $t('SeaExport.Add') }}</el-button>
              <el-button no="3" type="danger" :disabled="readonly" style="float:right" @click="delHandler">{{ $t('SeaExport.Delete') }}</el-button>
            </div>
          </div>
          <div class="section" style="margin-left:10px;flex: 1">
            <cargo-ag-grid
              no="4"
              :grid-options="right.gridOptions"
              :grid-params.sync="gridParams"
              :column-defs="rightColumnDefs"
              :row-data="containers"
              style="width:100%;height:350px"
              @gridReady="params=>{right.gridApi=params.api}"
            />
          </div>
        </div>

        <div class="section" style="flex: 1" :style="{flexDirection: 'row',justifyContent:'flex-start'}">
          <el-form :disabled="vgmReadonly" label-width="85px" label-position="left">
            <el-form-item label-width="0">
              <span>{{ $t('SeaExport.Shipper') }}</span>
              <span style="color:red">（MAX:45）</span>
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine1"
                no="5"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine2"
                no="6"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine3"
                no="7"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine4"
                no="8"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine5"
                no="9"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),form.mark,val=>{form.mark=val})"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine6"
                no="10"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <el-input
                v-model="selectedVgm.shipperLine7"
                no="11"
                style="width:300px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine)"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="vgmReadonly" label-width="90px" label-position="left" style="padding:0 10px;margin-top: 39px;">
            <el-form-item :label="$t('SeaExport.VgmContactPerson')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.shipperContact" no="12" style="width:300px" />
              <span style="color:red">（MAX:100）</span>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VgmContactEmailAddress')" class="custom">
              <el-input v-model="selectedVgm.shipperContactEmail" no="13" style="width:300px" />
              <span style="color:red">（MAX:100）</span>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VgmContactWay')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.shipperContactWay" no="14" style="width:300px" />
              <span style="color:red">（MAX:100）</span>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VgmResponsiblePerson')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.shipperPerson" no="15" style="width:300px" />
              <span style="color:red">（MAX:100）</span>
            </el-form-item>
          </el-form>
          <el-form :disabled="vgmReadonly" label-width="90px" label-position="left">
            <el-form-item class="label-none custom">
              <span>VGM WEIGHING COMPANY</span>
              <span style="color:red">（MAX:100）</span>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactPerson')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.companyContact" no="16" style="width:300px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactEmailAddress')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.companyContactEmail" no="17" style="width:300px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactWay')" class="custom">
              <el-input v-model="selectedVgm.companyContactWay" no="18" style="width:300px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactAddress')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.companyAddress" no="19" style="width:300px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ResponsiblePerson')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.companyPrincipal" no="20" style="width:300px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CompanyName')" class="custom">
              <cargo-english-words-input v-model="selectedVgm.companyName" no="21" :auto-uppercase="true" style="width:300px" />
            </el-form-item>
          </el-form>
        </div>

        <!-- 高级文本弹框 -->
        <el-dialog
          v-el-drag-dialog
          :visible.sync="advanceTextDialog.visible"
          :title="advanceTextDialog.title"
          width="600px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <el-input v-model="advanceTextDialog.value" type="textarea" rows="10" />
          <span slot="footer">
            <el-button no="22" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
            <el-button
              no="23"
              @click="advanceTextDialog.visible=false"
            >{{ $t('common.btn.close') }}</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>

import { vgmList } from '@/api/seaExport/vgm'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { Vgm } from '@/class/model/booking/Vgm'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import CargoEnglishWordsInput from '@/components/Cargo/Common/cargoEnglishWordsInput'
import StrUtils from '@/utils/StrUtils'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import SeaHouseVgm from '@/views/cargo/v0/SeaExport/components/booking/vgm/seahouseVgm'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { deepCopy } from '@/utils/commonUtil'
import { getConfigForCurrentTenant } from '@/api/sysManage/baseConfig/vasChannelConfig'
import { VGM_CHANNEL_RONGE_TONG } from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'TabVgm',
  components: { SeaHouseVgm, CargoAdvanceSelect, CargoDateTimeFieldInput, CargoEnglishWordsInput },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      vgmChannels: SeaExportConstants.VGM_CHANNELS,
      initialForm: {},
      left: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: this.dgVGMClick
        },
        rowData: [],
        gridApi: null
      },
      gridParams: {},
      right: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      job: new SeaExportJob().fillDefaultValue().getData(),
      selectedVgm: new Vgm().fillDefaultValue().getData(),
      vgms: [],
      containers: [],
      delVgmUuids: [], // 记录删除的uuid
      cargoDocsOptions: [], // vgm grid refNo下拉框数据
      weightObjs: [{ key: 'SM1', weightLabel: 'SM1' }, { key: 'SM2', weightLabel: 'SM2' }], // container grid vgm称重方法下拉框数据
      vasChannel: 0 // VGM配置通道
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    vgmReadonly() {
      return this.action === 'look' || this.vgms.length === 0
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    // vgm 左侧grid
    leftColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          width: 100,
          cellRenderer: (params) => {
            return this.noLabelFunc(params.data)
          }
        },
        {
          headerName: 'Ref NO.',
          field: 'cargoDocUuid',
          width: 110,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'label',
              value: 'cargoDocUuid'
            },
            attrs: {
              cellSelectAttrs: { fullOptionsCBFunc: () => [...this.cargoDocsOptions] }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        }
      ]
      return columnDefs
    },
    // vgm 右侧grid
    rightColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.EmptyContainerWeight'),
          field: 'containerWeight',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeight'),
          field: 'vGMWeight',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeighingMethod'),
          field: 'vGMWeightingMeothd',
          width: 140,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'weightLabel',
              value: 'key'
            },
            attrs: {
              cellSelectAttrs: { fullOptions: this.weightObjs }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeighingTime'),
          field: 'vGMWeightingTime',
          width: 320,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-date-time-field-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeighingPlace'),
          field: 'vGMWeightingPlace',
          width: 140,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            // tag: 'cargo-english-words-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 100,
          cellRenderer: (params) => {
            return this.usageQuantityLabelFunction(params.data, 'quantity')
          }
        },
        {
          headerName: this.$t('SeaExport.CargosGrossWeight'),
          field: 'weight',
          width: 120,
          cellRenderer: (params) => {
            return this.usageQuantityLabelFunction(params.data, 'weight')
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return this.usageQuantityLabelFunction(params.data, 'cubage')
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) }
            // isEdit: this.isEdit,
            // tag: 'cargo-english-words-input',
            // valueChanged: p => { this.onCellChange(p) }
          }
        }
      ]
      return columnDefs
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isWse() { // 未斯
      return this.job.vgmChannel === SeaExportConstants.VGM_CHANNEL_WSE.code
    },
    isRongETong() { // 荣e通
      return this.job.vgmChannel === SeaExportConstants.VGM_CHANNEL_RONGE_TONG.code
    },
    localVgmChannel: {
      get() {
        return this.job.vgmChannel === 0 ? 0 : 1
      },
      set(value) {
        if (value === 1) {
          this.vasChannel === 0 ? this.job.vgmChannel = SeaExportConstants.VGM_CHANNEL_RONGE_TONG.code : this.job.vgmChannel = this.vasChannel
        } else {
          this.job.vgmChannel = 0
        }
        return value
      }
    }
  },
  watch: {
    'job.vgmChannel': function(newVal) {
      LocalStorageUtils.setConfiguration('vgmChannel', newVal)
    }
  },
  created() {
    this.initialForm = this.form
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        this.setDefaultVGMWeightingMethod()
        return
      }
      this.job = row
      const { data: vasConfig } = await getConfigForCurrentTenant()
      if (vasConfig) {
        this.vasChannel = vasConfig.vgmChannel
      }
      if (!row.uuid) {
        // 获取选择的通道
        if (this.vasChannel !== 0) {
          this.job.vgmChannel = this.vasChannel
        } else {
          this.job.vgmChannel = 0
        }
        return
      }
      if (this.job.vgmChannel === '') {
        if (this.vasChannel !== 0) {
          this.job.vgmChannel = this.vasChannel
        } else {
          this.job.vgmChannel = 0
        }
      }
      const jobClass = new SeaExportJob(this.job)
      await Promise.all([
        jobClass.getContainers(),
        jobClass.getCargoDoc(),
        jobClass.getManifestInfos()
      ])
      this.loadVgms2Handler()
      this.setDefaultVGMWeightingMethod()
      this.containers = this.job.containers
      await this.fillView(row)
    },
    // 加载数据
    async fillView(row) {
      // todo job.js 上统一获取(待定)
      if (this.job.uuid) {
        if (this.job.vgms) {
          this.vgms = this.job.vgms
        } else {
          const vgmObj = await vgmList({ jobUuid: this.job.uuid }).then(res => res.data)
          this.vgms = vgmObj.vgmList
        }
      } else {
        this.vgms = []
      }
      this.job.vgms = this.vgms
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { vgms: deepCopy(this.job.vgms) })
      }
      // 默认选中第一行
      if (this.job.vgmChannel === 0 && this.vgms && this.vgms.length > 0) {
        this.$nextTick(async() => {
          await this.setGridSelect()
        })
      }
      if (this.job.vgmChannel === 1 || this.isWse || this.isRongETong) {
        await this.$refs['seaHouseVgm'].loadData()
      }
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setGridSelect(selectLastRow = false) {
      const nodes = this.left.gridApi.getRenderedNodes()

      // 选中最后一行记录(用于 行 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            item.setSelected(true)
            this.selectedVgm = item.data
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          item.setSelected(true)
          this.selectedVgm = item.data
          break
        }
      }
    },
    loadVgms2Handler() {
      this.cargoDocsOptions = []
      for (const doc of this.job.cargoDoc) {
        if (!doc.uuid) continue
        if (doc.docType === CargoDocConsts.MBL) {
          if (this.job.mbl) {
            if (!this.isDuplicateCargoDoc(this.cargoDocsOptions, doc)) {
              this.cargoDocsOptions.push({ label: this.job.mbl, cargoDocUuid: doc.uuid })
            }
          }
        } else if (doc.docType === CargoDocConsts.MBL2 && this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
          if (doc.mblNbr2) {
            if (!this.isDuplicateCargoDoc(this.cargoDocsOptions, doc)) {
              this.cargoDocsOptions.push({ label: doc.mblNbr2, cargoDocUuid: doc.uuid })
            }
          }
        }
      }
    },
    // 判断cargoDocs中是否包含了doc
    isDuplicateCargoDoc(cargoDocs, doc) {
      let result = false
      if (cargoDocs && cargoDocs.length > 0) {
        for (const obj of cargoDocs) {
          if (obj.cargoDocUuid === doc.uuid) {
            result = true
          }
        }
      }
      return result
    },
    getSubmitData() {
      const data = {
        vgms: this.vgms,
        delVgmUuids: this.delVgmUuids,
        containers: this.containers
      }
      // 新增不单独保存job
      if (this.job.uuid) {
        data.job = this.job
      }
      if (this.job.vgmChannel === 1 || this.isWse || this.isRongETong) {
        const obj = this.$refs['seaHouseVgm'].getSubmitData()
        data.vgmInfoList = obj.vgmInfoList
        data.delvgmInfoUuids = obj.delvgmInfoUuids
        data.delVgmContainerKeys = obj.delVgmContainerKeys
      }
      return data
    },
    // 切换VGM
    dgVGMClick(event) {
      if (!event.data) {
        return
      }
      this.selectedVgm = event.data
    },
    onCellChange(params) {
      if (params.field === 'cargoDocUuid') {
        if (!this.dropdownlistChangingHandler(params.data.cargoDocUuid)) {
          params.data.cargoDocUuid = params.value = ''
          this.left.gridApi.setRowData(this.vgms)
          return
        }
      }
      // VGM称重方法选择SM2的时候，VGM重量系统自动计算，自动带入数据。计算公式为：VGM重量=箱重+货重。
      if (params.field === 'vGMWeightingMeothd') {
        ContainerUtil.refreshVgmWeight(params.data)
      }
    },
    // refNo 选择框判断
    dropdownlistChangingHandler(value) {
      if (!value) return true

      const item = new Map()
      // 已经被选中的 cargoDoc（排除当前vgm）
      for (const obj of this.vgms) {
        if (item.has(obj.cargoDocUuid)) {
          this.$message.warning('Reference NO.' + this.$t('SeaExport.HasBeenSelected'))
          return false
        }
        item.set(obj.cargoDocUuid, obj.cargoDocUuid)
      }
      return true
    },
    // 新增 vgm
    addHandler() {
      const vgm = new Vgm().fillDefaultValue().getData()
      vgm.jobUuid = this.job.uuid
      this.vgms.push(vgm)
      /* this.fillModel()
      this.changeVGM()*/
      if (this.vgms.length === 1) {
        for (const container of this.containers) {
          container.wGMWeightingMeothd = 'SM2'
          ContainerUtil.refreshVgmWeight(container)
        }
      }
      if (this.job && !StrUtils.isEmpty(this.job.mbl)) {
        for (const doc of this.job.cargoDoc) {
          //   需要重写doc.vgm == null
          if (doc.docType === CargoDocConsts.MBL && !this.checkDocUuidUsed(doc.uuid)) {
            vgm.cargoDocUuid = doc.uuid
            break
          }
        }
      }

      this.$nextTick(() => {
        this.setGridSelect(true)
        this.dgVGMClick({ data: vgm })
      })
    },
    // 判断 doc uuid 是否已使用
    checkDocUuidUsed(docUuid) {
      return !!this.vgms.find(p => p.cargoDocUuid === docUuid)
    },
    // 删除 vgm
    delHandler() {
      // 移除
      this.$confirm(this.$t('Message.DeleteTheVgmInformation'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const index = this.vgms.indexOf(this.selectedVgm)
        if (this.selectedVgm.uuid) {
          this.delVgmUuids.push(this.selectedVgm.uuid)
        }
        this.vgms.splice(index, 1)
        this.$nextTick(() => {
          this.setGridSelect(false)
          this.dgVGMClick({ data: this.selectedVgm })
        })
      })
    },
    // 生成序号
    noLabelFunc(data) {
      let no = ''
      if (this.vgms && this.vgms.indexOf(data) > -1) {
        no = this.vgms.indexOf(data) + 1
      }
      return no
    },
    // 箱子件数 箱子重量 箱子体积（合并使用一个方法）
    usageQuantityLabelFunction(data, column) {
      const container = data
      if (container == null) { return '' }

      const containerUsage = container.containerUsage
      if (containerUsage == null) { return '' }

      let quantity = 0
      for (const c of containerUsage) {
        quantity += c[column]
      }
      if (column === '') {
        return quantity === 0 ? '' : quantity.toString()
      } else {
        return quantity === 0 ? '' : ColumnUtils.formatNumber(quantity, 3)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        if (!this.selectedVgm['shipperLine' + i]) continue
        result += this.selectedVgm['shipperLine' + i]
        result += '\n'
      }
      return result + (this.selectedVgm['shipperLine7'] || '')
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.selectedVgm['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.selectedVgm['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.selectedVgm['shipperLine' + i] = ''
      }
    },
    showAdvanceTextDialog(title, value, successCallback) {
      if (this.vgmReadonly) {
        return
      }
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 组装打印参数
    getPrintData() {
      if (!this.selectedVgm || !this.selectedVgm.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectTheDesiredPrintVgm'))
        return
      }
      const params = {}
      params.VGM_UUID = this.selectedVgm.uuid
      params.category = 'VGM'
      params.ctx = new Vgm(this.selectedVgm)
      // TemplateSelectorWin.getInstance().showThisWin(vgm, "VGM", params, this);
      this.$logger.log('params', params)
      return params
    },
    syncData(data) {
      this.$emit('syncData', data)
    },
    setDefaultVGMWeightingMethod() {
      if (this.isEdit) {
        for (const container of this.job.containers) {
          if (!container.vGMWeightingMeothd) {
            container.vGMWeightingMeothd = 'SM2'
            ContainerUtil.refreshVgmWeight(container)
          }
        }
      }
    },
    changeLocalVgmChannel() {
      if (this.localVgmChannel === SeaExportConstants.VGM_CHANNEL_DEFAULT.code) {
        this.setDefaultVGMWeightingMethod()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
